import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { OcorrenciaDocumentoParams } from '@core/models';


@Injectable({
  providedIn: 'root',
})
export class DocumentcorrenciaService {
  private readonly endpoint = '/api/Documento/Ocorrencia';

  constructor( private readonly apiService: ApiService, ) {}
  
  gerarDocumento(params: OcorrenciaDocumentoParams,): Observable<Blob> {
    const httpParams = this.criarParametros(params);
    return this.apiService.get<Blob>(
      this.endpoint,
      httpParams,
      {
        responseType: 'blob',
      },
    );
  }

  private criarParametros(params: OcorrenciaDocumentoParams,): HttpParams {
    let httpParams = new HttpParams(); 

      httpParams = httpParams.set('PeriodoEnum', String(params.PeriodoEnum),);

      if(params.DataInicioDe){
        httpParams = httpParams.set('DataInicioDe', params.DataInicioDe,);
      }

      if(params.DataInicioAte){
        httpParams = httpParams.set('DataInicioAte', params.DataInicioAte,);
      }

      if(params.ClienteId){
        httpParams = httpParams.set('ClienteId', String(params.ClienteId),);
      }

      if(params.PostoId){
        httpParams = httpParams.set('PostoId', String(params.PostoId),);
      }

      if(params.TurnoId){
        httpParams = httpParams.set('TurnoId', String(params.TurnoId),);
      }

      if(params.EfetivoId){
        httpParams = httpParams.set('EfectivoId', String(params.EfetivoId),);
      }

      if(params.RondaId){
        httpParams = httpParams.set('RondaId', String(params.RondaId),);
      }

      if(params.Criticidade){
        httpParams = httpParams.set('Criticidade', String(params.Criticidade),);
      }

      if(params.TipoOcorrencia){
        httpParams = httpParams.set('TipoOcorrencia', String(params.TipoOcorrencia),);
      }

      if(params.formatoDocumento){
        httpParams = httpParams.set('formatoDocumento', String(params.formatoDocumento),);
      }

    return httpParams;
    }


    criarUrlDownload( params: OcorrenciaDocumentoParams, baseUrl: string, ): string {
      const httpParams = this.criarParametros(params);
      return `${baseUrl}${this.endpoint}?${httpParams.toString()}`;
    }
}
